import useHttp from './use-http';

export function useContentManualStats(contactId) {
    const { http } = useHttp();

    const getContent = (id) => {
        return http.get(`/contact/${contactId}/content/${id}`);
    };

    const updateContentManualStats = (id, input) => {
        return http.post(`/contact/${contactId}/content/${id}/update-manual-stats`, input);
    };

    return {
        getContent,
        updateContentManualStats
    };
}
